import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Save } from "lucide-react";
import { toast } from "sonner";

export default function EmailTemplatesManager() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/email-templates").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const edit = (key, field, val) => setRows((s) => s.map((t) => (t.key === key ? { ...t, [field]: val } : t)));
  const save = async (t) => { try { await api.put(`/email-templates/${t.key}`, { name: t.name, subject: t.subject, body: t.body }); toast.success("Saved"); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };
  return (
    <div className="space-y-5" data-testid="email-templates-manager">
      <p className="text-sm text-slate-500">Edit the emails sent to candidates during recruitment. Placeholders: <code className="text-[#2EA3FD]">{"{{candidate_name}}"}</code>, <code className="text-[#2EA3FD]">{"{{job_title}}"}</code>, <code className="text-[#2EA3FD]">{"{{org_name}}"}</code>, <code className="text-[#2EA3FD]">{"{{interview_details}}"}</code>. The acknowledgement sends automatically when someone applies.</p>
      {rows.map((t) => (
        <div key={t.key} className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-3" data-testid={`email-card-${t.key}`}>
          <h3 className="font-semibold text-[#0B1A2F]">{t.name}</h3>
          <div><Label className="text-xs text-slate-500">Subject</Label><Input value={t.subject || ""} onChange={(e) => edit(t.key, "subject", e.target.value)} data-testid={`email-subject-${t.key}`} /></div>
          <div><Label className="text-xs text-slate-500">Body</Label><Textarea rows={8} value={t.body || ""} onChange={(e) => edit(t.key, "body", e.target.value)} className="text-sm leading-relaxed" data-testid={`email-body-${t.key}`} /></div>
          <Button onClick={() => save(t)} className="bg-[#2EA3FD] hover:bg-[#1B8EE6]" data-testid={`email-save-${t.key}`}><Save size={15} className="mr-2" />Save</Button>
        </div>
      ))}
      {rows.length === 0 && <p className="text-sm text-slate-400">Loading…</p>}
    </div>
  );
}
